import React, { useEffect, useState } from 'react';
import { Loader2, BarChart3, ChevronRight } from 'lucide-react';
import { atlasApi, AtlasUser, FeedbackCiclo } from '../shared/atlasApi';

interface Props {
  user: AtlasUser;
  onAbrir: (cicloId: string, funccodi: number) => void;
}

function fdata(s?: string | null) {
  if (!s) return '—';
  try { return new Date(s).toLocaleDateString('pt-BR'); } catch { return s; }
}

const MeusRelatorios: React.FC<Props> = ({ user, onAbrir }) => {
  const [ciclos, setCiclos] = useState<FeedbackCiclo[]>([]);
  const [meuFunccodi, setMeuFunccodi] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);
  const [erro, setErro] = useState<string | null>(null);

  useEffect(() => {
    let cancel = false;
    Promise.all([atlasApi.discMeu(user), atlasApi.listarCiclos(user, { status: 'encerrado' })])
      .then(([me, lista]) => {
        if (cancel) return;
        setMeuFunccodi(me.funccodi ?? null);
        const fc = me.funccodi;
        const meus = (lista.itens || []).filter((c: FeedbackCiclo) => fc != null && (c.participantes_funccodi || []).includes(fc));
        setCiclos(meus);
      })
      .catch(e => { if (!cancel) setErro(e.message || 'Erro ao carregar'); })
      .finally(() => { if (!cancel) setLoading(false); });
    return () => { cancel = true; };
  }, [user]);

  if (loading) return <div className="p-10 text-center text-gray-400"><Loader2 className="w-6 h-6 animate-spin mx-auto mb-2" /> Carregando...</div>;
  if (erro) return <div className="bg-rose-50 border border-rose-200 rounded-2xl p-6 text-rose-700">{erro}</div>;

  return (
    <div className="max-w-3xl">
      <h2 className="text-lg font-bold text-gray-900 flex items-center gap-2 mb-4"><BarChart3 className="w-5 h-5 text-emerald-500" /> Meus relatórios</h2>
      {meuFunccodi == null ? (
        <div className="bg-amber-50 border border-amber-200 rounded-2xl p-6 text-amber-700">Você não possui registro de funcionário CLT.</div>
      ) : ciclos.length === 0 ? (
        <div className="bg-white rounded-2xl border border-gray-200 p-10 text-center text-gray-400">Nenhum relatório disponível ainda (ciclos encerrados aparecem aqui).</div>
      ) : (
        <ul className="space-y-2">
          {ciclos.map(c => (
            <li key={c._id}>
              <button onClick={() => onAbrir(c._id, meuFunccodi)} className="w-full text-left bg-white rounded-2xl border border-gray-200 p-4 hover:border-purple-300 hover:shadow-sm transition flex items-center gap-3">
                <div className="flex-1">
                  <div className="font-medium text-gray-900">{c.titulo}</div>
                  <div className="text-xs text-gray-400">Encerrado · {fdata(c.data_fim)}</div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MeusRelatorios;
